import type { EscalationContactRole } from '../types/escalationContact.types';

export const ESCALATION_CONTACT_ROLES: {
  value: EscalationContactRole;
  label: string;
  badgeClass: string;
}[] = [
  { value: 'Junior', label: 'Junior Clinician', badgeClass: 'esc-role-badge--junior' },
  { value: 'Consultant', label: 'Consultant', badgeClass: 'esc-role-badge--consultant' },
  { value: 'HOD', label: 'HOD', badgeClass: 'esc-role-badge--hod' },
  { value: 'On-call', label: 'On-call Clinician', badgeClass: 'esc-role-badge--oncall' },
];

export const RIS_CONFIG_TABS = [
  { id: 'routing', label: 'Routing Rules', disabled: false },
  { id: 'worklist', label: 'Worklist Priority', disabled: false },
  { id: 'assignment', label: 'Study Assignment', disabled: false },
  { id: 'capacity', label: 'Capacity', disabled: true },
  { id: 'critical-escalation', label: 'Critical Escalation', disabled: false },
  { id: 'patient-access-link-validity', label: 'Patient Access Link Validity', disabled: false },
  { id: 'notification-retry', label: 'Notification Retry', disabled: false },
  { id: 'appointment-reminder', label: 'Appointment Reminder', disabled: false },
  { id: 'peer-review', label: 'Peer Review', disabled: false },
] as const;

export function getRoleMeta(role: EscalationContactRole) {
  return ESCALATION_CONTACT_ROLES.find(item => item.value === role) || ESCALATION_CONTACT_ROLES[0];
}
